import React from 'react'
export default function footer() {
    return (
      <div className="footer">
        <p>
          Made by <a href="https://d-s.sd">Abobaker Hilal</a>
        </p>
        <p>
          <a href="https://github.com/beko09/Multilingual-website-with-react-redux">
            github
          </a>
        </p>
      </div>
    );
}
